import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  
  constructor(private loaderService: LoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip loader for certain requests (you can customize this)
    if (this.shouldSkipLoader(request)) {
      return next.handle(request);
    }

    // Show loader when request starts
    this.loaderService.show();

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          // You can add specific handling for different event types if needed
          if (event instanceof HttpResponse) {
            // Response received successfully
          }
        },
        error: (error: HttpErrorResponse) => {
          // Handle error if needed
          console.error('HTTP Error occurred:', error);
        }
      }),
      finalize(() => {
        // Hide loader when request completes (success or error)
        this.loaderService.hide();
      })
    );
  }

  /**
   * Determine if loader should be skipped for this request
   * You can customize this method to skip loader for specific endpoints
   */
  private shouldSkipLoader(request: HttpRequest<any>): boolean {
    // Skip loader for specific URLs or request types
    const skipLoaderUrls = [
      '/api/health-check',
      '/api/ping',
      '/assets/',
      // Add more URLs that shouldn't trigger the loader
    ];

    // Skip if request has a custom header to bypass loader
    if (request.headers.has('X-Skip-Loader')) {
      return true;
    }

    // Skip for specific URL patterns
    return skipLoaderUrls.some(url => request.url.includes(url));
  }
} 